var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48193 11.7479V26.3979C3.48193 29.2586 5.51456 30.433 7.98383 29.0177L11.5221 27.0001C12.29 26.5635 13.5698 26.5183 14.3678 26.9249L22.2724 30.8847C23.0704 31.2762 24.3502 31.2461 25.1181 30.8094L31.6376 27.0754C32.4657 26.5936 33.1583 25.4192 33.1583 24.4556V9.80563C33.1583 6.94489 31.1257 5.77049 28.6564 7.1858L25.1181 9.20337C24.3502 9.64001 23.0704 9.68518 22.2724 9.27865L14.3678 5.33385C13.5698 4.94238 12.29 4.97249 11.5221 5.40913L5.00264 9.14314C4.15948 9.62495 3.48193 10.7994 3.48193 11.7479Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9224 6.05652V25.63",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7178 10.0013V30.1469",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.4672e1c3ec81a692aa103dd3d8dd6b5c.svg";
export { ForwardRef as ReactComponent };